"use strict";

require("core-js/modules/es7.symbol.async-iterator");
require("core-js/modules/es6.symbol");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.date.to-string");
require("core-js/modules/es6.array.for-each");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.regexp.search");
require("core-js/modules/es6.array.find");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.array.iterator");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.map");
require("core-js/modules/es6.object.define-property");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var tslib_1 = require("tslib");
var $ = require("jquery");
var Body_1 = require("../Core/Body");
var Languages_1 = require("../Core/Languages");
var Events_1 = require("../Core/Events");
require("selectric");
var ts_debounce_1 = require("ts-debounce");
var noUiSlider = require("nouislider");
var Responsiveness_1 = require("Core/Responsiveness");
var CommonFunctions_1 = require("./CommonFunctions");
exports.Filters = function () {
  var Selector = {
    FILTER_FORM: "#filter-form",
    FILTER_SHOW_TILE_NAMES_BTN: "#filter-tile--show_names_btn",
    FILTER_SELECTS: '.filter-selects',
    FILTER_TOGGLER: '.js_filter_toggler',
    FILTER_TILE: '.av-material-color--item',
    FILTER_COLORS_CLASS: '.av-material-color--elem',
    PAGE: 'button.page-link',
    DELETE_FILTER: '.js_delete_filter',
    DELETE_ALL_FILTERS: 'button[name=fltr_dell_all]',
    SHOW_MORE_LESS_BUTTON: '[data-sh]',
    FILTER_SELECT: '.filter-selection',
    FILTER_SELECT_OPTION: '.filter-selection option',
    FILTER_EXPAND_TOGGLER: '.js_filter_expand_toggler',
    FILTER_CONTAINER: '.js_filter_container',
    FILTER_COMPONENT: '#collapseFilters',
    SORTING_COMPONENT: '#collapseSorting',
    FILTERS_TAGS: {
      TAG: '.filters-tags .badge'
    },
    BTN_APPLY_FILTERS: '.btn-apply-filters',
    FILTER_CONTENT: '.js_filter_content'
  };
  var submitFilterForm = ts_debounce_1.debounce($(Selector.FILTER_FORM).submit, 500);
  var TransitionDuration = '0.25s';
  function selectFilter() {
    var selected = $(this).hasClass('selected');
    $(Selector.FILTER_TILE).removeClass('selected');
    $(Selector.FILTER_COLORS_CLASS).prop("checked", false);
    if (selected) {
      $(this).removeClass('selected');
    } else {
      $(this).addClass('selected');
      $(this).parent().next().prop("checked", true);
    }
  }
  function applyFilters() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, selectFilter()];
          case 1:
            _a.sent();
            submitFilterForm();
            return [2];
        }
      });
    });
  }
  function prepareElementToSubmit() {
    $(this).addClass('js_active_to_submit');
  }
  function toggleTileNamesVisibility() {
    var currentBtnText = $(Selector.FILTER_SHOW_TILE_NAMES_BTN).text();
    var lang = Languages_1.getCurrentLanguage;
    $(Selector.FILTER_TILE).each(function (index, element) {
      $(element).tooltip("toggle");
    });
    if (lang == "pl") {
      currentBtnText == "Pokaż nazwy filtrów" ? $(Selector.FILTER_SHOW_TILE_NAMES_BTN).text("Ukryj nazwy filtrów") : $(Selector.FILTER_SHOW_TILE_NAMES_BTN).text("Pokaż nazwy filtrów");
    } else {
      currentBtnText == "Show filter names" ? $(Selector.FILTER_SHOW_TILE_NAMES_BTN).text("Hide filter names") : $(Selector.FILTER_SHOW_TILE_NAMES_BTN).text("Show filter names");
    }
  }
  function collectActiveFilters() {
    var e_1, _a;
    var mapInputValues = new Map();
    var selectedFields = {};
    var inputText = $(Selector.FILTER_FORM).find('input[type=\'text\'][name]');
    var inputNumber = $(Selector.FILTER_FORM).find('input[type=\'number\'][name].js_active_to_submit');
    var inputHidden = $(Selector.FILTER_FORM).find('input[type=\'hidden\'][name]');
    var inputCheckbox = $(Selector.FILTER_FORM).find('input[type=\'checkbox\'][name]');
    var inputCheckboxColor = $(Selector.FILTER_FORM).find('input[type=\'checkbox\'][name].js_active_to_submit');
    inputHidden.each(function () {
      if ($(this).val() !== null) {
        selectedFields[$(this).attr('name')] = $(this).val();
      }
    });
    inputText.each(function () {
      if ($(this).val() !== null) {
        selectedFields[$(this).attr('name')] = $(this).val();
      }
    });
    inputNumber.each(function () {
      if ($(this).val() !== null && $(this).val() !== "") {
        mapInputValues.set($(this).attr('name'), $(this).val());
      } else {
        mapInputValues.set($(this).attr('name'), $(this).attr('value'));
      }
    });
    inputCheckbox.each(function () {
      if ($(this).prop('checked')) {
        selectedFields[$(this).attr('name')] = $(this).val();
      }
    });
    inputCheckboxColor.each(function () {
      selectedFields[$(this).attr('name')] = $(this).val();
    });
    try {
      for (var mapInputValues_1 = tslib_1.__values(mapInputValues), mapInputValues_1_1 = mapInputValues_1.next(); !mapInputValues_1_1.done; mapInputValues_1_1 = mapInputValues_1.next()) {
        var _b = tslib_1.__read(mapInputValues_1_1.value, 2),
          key = _b[0],
          value = _b[1];
        selectedFields[key] = value;
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (mapInputValues_1_1 && !mapInputValues_1_1.done && (_a = mapInputValues_1.return)) _a.call(mapInputValues_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    return selectedFields;
  }
  function getLocation() {
    var newLocation = window.location.origin + window.location.pathname;
    if (newLocation.slice(-1) != '/') {
      newLocation += '/';
    }
    return newLocation;
  }
  function onApplyFilters(event) {
    event.preventDefault();
    return redirectFormToNewLocation(getLocation(), $.param(collectActiveFilters()));
  }
  function onPreventSubmit(event) {
    event.preventDefault();
    var urlParams = new URLSearchParams(window.location.search);
    var pages = ["0", "1"];
    var inputSelect = $(Selector.FILTER_FORM).find('select[name].js_active_to_submit');
    var buttonSelect = $(Selector.FILTER_FORM).find('button.js_active_to_submit');
    inputSelect.each(function () {
      if (_typeof($(this).val()) == 'object') {
        if (Object.keys($(this).val()).length > 0) {
          urlParams.set($(this).attr('name'), $(this).val());
        }
      } else if ($(this).val() !== null) {
        var option = $(this).find('option:selected');
        if (urlParams.has($(this).attr('name'))) {
          urlParams.delete($(this).attr('name'));
        }
        if (option.data('default') !== true) {
          urlParams.set($(this).attr('name'), $(this).val());
        }
      }
    });
    urlParams.delete('page');
    if (buttonSelect.length > 0) {
      if (buttonSelect.attr('name') == 'page') {
        urlParams.set(buttonSelect.attr('name'), buttonSelect.val());
      } else if (buttonSelect.data('delete-filter-all') === true) {
        urlParams = new URLSearchParams('');
      } else if (buttonSelect.data('delete-filter') === true) {
        var filterName = buttonSelect.data('delete-filter-name');
        var filterValue = buttonSelect.val();
        var filterNameWithBlanValue_1 = filterName + "[]";
        var filterNameWithValueValue = buttonSelect.data('delete-filter-name-with-value');
        if (urlParams.has(filterNameWithBlanValue_1)) {
          var allValuesByName = urlParams.getAll(filterNameWithBlanValue_1);
          allValuesByName.splice(filterValue, 1);
          urlParams.delete(filterNameWithBlanValue_1);
          allValuesByName.forEach(function (currentVaalue) {
            urlParams.append(filterNameWithBlanValue_1, currentVaalue);
          });
        }
        if (urlParams.has(filterNameWithValueValue)) {
          urlParams.delete(filterNameWithValueValue);
        }
      } else {
        urlParams.set(buttonSelect.attr('name'), buttonSelect.val());
      }
    }
    return redirectFormToNewLocation(getLocation(), urlParams.toString());
  }
  function redirectFormToNewLocation(newLocation, newGetQuery) {
    if (newGetQuery) {
      newLocation = newLocation + '?' + newGetQuery;
    }
    window.location.href = newLocation;
  }
  function showMoreLess() {
    var SH = $('#' + $(this).attr('data-sh'));
    SH.slideToggle();
    if (SH.is(':hidden')) {
      $(this).slideToggle();
    } else {
      SH.next().slideToggle();
    }
  }
  function filterSlider() {
    var $this = document.querySelectorAll('.filter-slider');
    var _loop_1 = function _loop_1() {
      var startSlider = $this[i].querySelector('.js_filter_slider');
      var min_input = $this[i].querySelector('.range-products-min');
      var min = parseFloat(min_input.getAttribute('data-min'));
      var min_value = parseFloat(min_input.value);
      var max_input = $this[i].querySelector('.range-products-max');
      var max = parseFloat(max_input.getAttribute('data-max'));
      var max_value = parseFloat(max_input.value);
      noUiSlider.create(startSlider, {
        start: [min_value, max_value],
        connect: true,
        range: {
          'min': [min],
          'max': [max]
        }
      });
      slider = startSlider;
      slider.noUiSlider.on('update', function (values, handle) {
        var value = values[handle];
        if (handle) {
          max_input.value = value;
        } else {
          min_input.value = value;
        }
      });
      min_input.addEventListener('change', function () {
        $(this).addClass('js_active_to_submit');
        slider.noUiSlider.set([this.value, null]);
      });
      max_input.addEventListener('change', function () {
        $(this).addClass('js_active_to_submit');
        slider.noUiSlider.set([null, this.value]);
      });
      slider.noUiSlider.on('change', function (values, handle) {
        var handleTarget;
        if (handle == 0) {
          handleTarget = 'range-products-min';
        } else {
          handleTarget = 'range-products-max';
        }
        var target = $(this.target.parentElement);
        applyCurrentFilterSliderInput(target, handleTarget);
      });
    };
    var slider;
    for (var i = 0; i < $this.length; i++) {
      _loop_1();
    }
  }
  function applyCurrentFilterSliderInput(targetFilter, inputClass) {
    $(targetFilter).find("." + inputClass).addClass('js_active_to_submit');
  }
  function filterSelection() {
    $('.filter-selection option').mousedown(function (e) {
      e.preventDefault();
      $(this).prop('selected', !$(this).prop('selected'));
      return false;
    });
  }
  function filterExpandingHandler() {
    var filters = $(Selector.FILTER_CONTAINER).find('.filter');
    var textElement = $(this).find('.text');
    var arrowElement = $(this).find('svg');
    if ($(this).data('status') === false) {
      filters.each(function (index, element) {
        $(element).removeClass('d-none').addClass('d-block');
      });
      var text = toggleName($(this).data('status'));
      textElement.text(text);
      arrowElement.removeClass('fa-chevron-down').addClass('fa-chevron-up');
      $(this).data('status', true);
    } else {
      filters.each(function (index, element) {
        if (index >= 4) {
          $(element).removeClass('d-block').addClass('d-none');
        }
      });
      var text = toggleName($(this).data('status'));
      textElement.text(text);
      arrowElement.removeClass('fa-chevron-up').addClass('fa-chevron-down');
      $(this).data('status', false);
    }
  }
  function toggleName(status) {
    var text;
    if (status == false) {
      switch (Languages_1.getCurrentLanguage) {
        case 'pl':
          text = 'Pokaż mniej';
          break;
        case 'ru':
          text = 'Показывай меньше';
          break;
        default:
          text = 'Show less';
      }
    } else {
      switch (Languages_1.getCurrentLanguage) {
        case 'pl':
          text = 'Pokaż więcej';
          break;
        case 'ru':
          text = 'Показать больше';
          break;
        default:
          text = 'Show more';
      }
    }
    return text;
  }
  function filtersRunner() {
    $(Selector.FILTER_SELECTS).selectric({
      disableOnMobile: false,
      nativeOnMobile: false,
      maxHeight: 200,
      responsive: true,
      forceRenderBelow: true
    });
    $(Selector.FILTER_SELECTS).on('selectric-before-open', function (event, element, selectric) {
      var selectMainElement = $(element).parent().parent();
      var filterBox = $(selectMainElement).next();
      CommonFunctions_1.hideSlideUp(selectMainElement);
      CommonFunctions_1.showSlideDown(filterBox);
      $(element).remove();
    });
  }
  function filtersHideForMobile() {
    if (Responsiveness_1.ActualScreen.WIDTH >= Responsiveness_1.Breakpoints.XL) {
      $(Selector.SORTING_COMPONENT).addClass('show');
      $(Selector.FILTER_COMPONENT).addClass('show');
    } else {
      $(Selector.SORTING_COMPONENT).removeClass('show');
      $(Selector.FILTER_COMPONENT).removeClass('show');
    }
  }
  function toggleTagCheckbox() {
    var forId = $(this).attr('for');
    var status = $(this).parent().parent().find("#" + forId).prop('checked');
    if (status == true) {
      $(this).parent().parent().find("#" + forId).prop('checked', false);
      $(this).removeClass('checked');
    } else {
      $(this).parent().parent().find("#" + forId).prop('checked', true);
      $(this).addClass('checked');
    }
    onApplyFilters(event);
  }
  function customSelectricHandler() {
    var status = $(this).find('input').prop('checked');
    status == true ? setCustomFilterStyling($(this), true) : setCustomFilterStyling($(this), false);
  }
  function setCustomFilterStyling(target, status) {
    if (status == true) {
      $(target).find('.js_filter_active_dot').show(), $(target).find('span').addClass('text-primary font-weight-medium');
    } else {
      $(target).find('span').removeClass('text-primary font-weight-medium');
      $(target).find('.js_filter_active_dot').hide();
    }
  }
  function toggleFilterBoxHandler() {
    var $this = $(this);
    arrowTogglerHandler($this);
  }
  function arrowTogglerHandler(element) {
    var arrow = $(element).parent().find('svg:first');
    if (!$(element).hasClass('collapsed')) {
      arrow.css({
        transform: 'rotate(0deg)',
        'transition-duration': TransitionDuration
      });
      $(element).addClass('collapsed');
    } else {
      arrow.css({
        transform: 'rotate(180deg)',
        'transition-duration': TransitionDuration
      });
      $(element).removeClass('collapsed');
    }
  }
  function changeDefaultFilterArrows() {
    if ($('.filter').length > 0) {
      $('.filter').each(function (index, element) {
        if ($(element).find('.filter-title').attr('aria-expanded') == 'true') {
          $(element).find('svg:first').css({
            transform: 'rotate(180deg)',
            'transition-duration': TransitionDuration
          });
        }
      });
    }
  }
  Events_1.onLoad(changeDefaultFilterArrows);
  Events_1.onLoad(filtersRunner);
  Events_1.onLoad(filterSlider);
  Events_1.onLoad(filterSelection);
  Events_1.onLoad(filtersHideForMobile);
  Events_1.onClick(Selector.FILTER_EXPAND_TOGGLER, filterExpandingHandler);
  Events_1.onClick(Selector.FILTERS_TAGS.TAG, toggleTagCheckbox);
  Events_1.onClick(Selector.FILTER_TOGGLER, customSelectricHandler);
  Body_1.$body.on("change", Selector.FILTER_SELECTS, applyFilters);
  Body_1.$body.on("click", Selector.FILTER_TILE, selectFilter);
  Body_1.$body.on("click", Selector.FILTER_TILE, applyFilters);
  Body_1.$body.on("click", Selector.PAGE, prepareElementToSubmit);
  Body_1.$body.on("click", Selector.DELETE_FILTER, prepareElementToSubmit);
  Body_1.$body.on("click", Selector.DELETE_ALL_FILTERS, prepareElementToSubmit);
  Body_1.$body.on("click", Selector.FILTER_SHOW_TILE_NAMES_BTN, toggleTileNamesVisibility);
  Body_1.$body.on('click', Selector.SHOW_MORE_LESS_BUTTON, showMoreLess);
  Body_1.$body.on("click", Selector.BTN_APPLY_FILTERS, onApplyFilters);
  Body_1.$body.on("submit", Selector.FILTER_FORM, onPreventSubmit);
  $("" + Selector.FILTER_CONTENT).on('hidden.bs.collapse', toggleFilterBoxHandler);
  $("" + Selector.FILTER_CONTENT).on('shown.bs.collapse', toggleFilterBoxHandler);
}();